<div class="hand-loader">
  <div class="hand-loader__container">
    <div class="hand-loader__circle"></div>
    <img class="hand-loader__3d-hand" src="assets/images/widget/loading_experience/interact-in-3d-hand.svg">
    <div class="hand-loader__label" >Interact in 3D</div>
  </div>
</div>
